import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

let browserLanguage = window.navigator.language && window.navigator.language.split('-')[0];

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  },
  it: {
    currency: {
      style: 'currency',
      currency: 'EUR'
    }
  }
};

const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  it: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
};

window.i4muiBrowserLanguage = browserLanguage || 'it';

export default new VueI18n({
  locale: window.i4muiBrowserLanguage,
  fallbackLocale: 'it',
  messages: loadLocaleMessages(),
  numberFormats,
  dateTimeFormats,
  silentFallbackWarn: true
});
